export const defaultMaxHeight = 686

export const internalExplorerUrl = 'https://scan.li.fi'

// Fits the longest Zcash unified address in the official test vectors (509 characters).
export const addressInputMaxLength = 512
